module.exports = __webpack_public_path__ + "static/media/vlinder-logo.1ee0744f.png";